"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5830],{

/***/ 82763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55150);
/* harmony import */ var _redux_action_productFiltersAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7330);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  > span {\n    margin-right: 10px;\n  }\n  .btn {\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    padding: 0 20px;\n    border-radius: 10px;\n  }\n\n  @media (max-width: 991px) {\n    justify-content: flex-start;\n  }\n  @media (max-width: 767px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  flex-direction: column;\n\n  & span {\n    margin-right: 10px;\n    text-align: end;\n    font-size: 14px;\n  }\n\n  grid-template-columns: repeat(3, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  & button {\n    border: none;\n    background: #3bb77e;\n    color: #fff;\n    border-radius: 10px;\n    font-size: 14px;\n    word-break: keep-all;\n    height: 30px;\n    :hover {\n      background-color: #fd7e14;\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: grid;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 120px;\n  height: 30px;\n  text-align: center;\n  padding: 0 10px;\n  margin-right: 10px;\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: 30px;\n  text-align: center;\n  border: 1px solid #ececec;\n  background-color: #fff;\n  border-radius: 10px;\n  margin-right: 10px;\n  padding: 0px 20px;\n\n  @media (max-width: 767px) {\n    font-size: 14px;\n    width: 100%;\n    max-width: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-right: 15px;\n  font-size: 14px;\n  color: #666;\n\n  @media (max-width: 767px) {\n    margin-bottom: 10px;\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var SizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-0"
})(_templateObject());
var MobileSizeFilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-1"
})(_templateObject1());
var SizeInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-b3d609b4-2"
})(_templateObject2());
var SizeSelect = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-b3d609b4-3"
})(_templateObject3());
// 사이즈 형식을 표시하는 레이블 컴포넌트 추가
var SizeFormatLabel = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b3d609b4-4"
})(_templateObject4());
var SizeFilter = function(param1) {
    var _$updateProductFilters = param1.updateProductFilters, productFilters = param1.productFilters, handleSizeFilter = param1.handleSizeFilter, viewHeight = param1.viewHeight, categorySizeSearch = param1.categorySizeSearch, selectedCategory = param1.selectedCategory;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        horizontal: "",
        vertical: "",
        height: "",
        range: ""
    }), selectedSizes = ref[0], setSizes = ref[1];
    // 선택된 카테고리에 따라 필터 타입 결정
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("default"), filterType = ref1[0], setFilterType = ref1[1]; // default, box 등
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // 선택된 카테고리에 따라 필터 타입 설정
        if (selectedCategory) {
            // 여러 카테고리가 선택된 경우 (공백으로 구분)
            var categoryArray = selectedCategory.split(" ");
            // 박스 카테고리 확인 (01, 02, 10 중 하나라도 포함되면 박스 타입)
            var isBoxCategory = categoryArray.some(function(cat) {
                return cat.startsWith("BOX") || cat === "01" || cat === "02" || cat === "10";
            });
            // 비닐봉투 카테고리 확인 (16, 17, 06)
            var isEnvelopeCategory = categoryArray.some(function(cat) {
                return cat === "16" || cat === "17" || cat === "06";
            });
            if (isBoxCategory) {
                // 박스 카테고리가 포함되어 있으면 박스 타입으로 설정
                setFilterType("box");
            } else {
                setFilterType("default");
            }
        }
    }, [
        selectedCategory,
        viewHeight
    ]);
    // 페이지 진입 시 초기 값 설정
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        _$updateProductFilters(_objectSpread({}, productFilters, {
            sizes: {
                horizontal: "",
                vertical: "",
                height: "",
                range: ""
            }
        }));
        if (!router.query.sizes) {
            setSizes({
                horizontal: "",
                vertical: "",
                height: "",
                range: ""
            });
        }
    }, [
        router.query
    ]);
    var handleFilter = function() {
        var hasValue = Object.entries(selectedSizes).filter(function(param) {
            var _param = _slicedToArray(param, 1), key = _param[0];
            return filterType === "box" || key !== "height";
        }) // 박스 타입이 아니면 height는 검사하지 않음
        .some(function(param) {
            var _param = _slicedToArray(param, 2), value = _param[1];
            return value > 0;
        });
        if (!hasValue) {
            return (0,_common_alert__WEBPACK_IMPORTED_MODULE_4__/* .failAlert */ .qh)("1\uAC1C \uC774\uC0C1\uC758 \uC870\uAC74\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
        }
        if (handleSizeFilter) {
            handleSizeFilter(selectedSizes);
        } else {
            _$updateProductFilters({
                sizes: selectedSizes,
                code: router.query.code,
                hash: router.query.hash || productFilters.hash
            });
        }
    };
    var onChangeSize = function(id) {
        return function(e) {
            setSizes(_objectSpread({}, selectedSizes, _defineProperty({}, id, e.target.value)));
        };
    };
    var handleInput = function(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            setTimeout(function() {
                handleFilter();
            }, 200);
        }
    };
    var sizes = [
        0,
        10,
        20,
        30,
        40,
        50,
        60
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85Cmm",
                        value: selectedSizes.horizontal,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85Cmm",
                        value: selectedSizes.vertical,
                        onKeyDown: handleInput
                    }),
                    filterType === "box" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774mm",
                        value: selectedSizes.height,
                        onKeyDown: handleInput
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "btn",
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(MobileSizeFilterWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("horizontal"),
                        placeholder: "\uAC00\uB85C",
                        value: selectedSizes.horizontal
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("vertical"),
                        placeholder: "\uC138\uB85C",
                        value: selectedSizes.vertical
                    }),
                    filterType === "box" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeInput, {
                        onChange: onChangeSize("height"),
                        placeholder: "\uB192\uC774",
                        value: selectedSizes.height
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SizeSelect, {
                        id: "sizeFilter",
                        name: "sizeFilter",
                        onChange: onChangeSize("range"),
                        value: selectedSizes.range,
                        children: sizes.map(function(el, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("option", {
                                value: el > 0 ? el : "",
                                children: [
                                    "\xb1 ",
                                    el
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: handleFilter,
                        children: "\uC0AC\uC774\uC988 \uAC80\uC0C9"
                    })
                ]
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        productFilters: state.productFilters
    };
};
var mapDidpatchToProps = {
    updateProductFilters: _redux_action_productFiltersAction__WEBPACK_IMPORTED_MODULE_6__/* .updateProductFilters */ .lG
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDidpatchToProps)(SizeFilter));


/***/ }),

/***/ 88722:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pagination(param) {
    var currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, pages = param.pages, setCurrentPage = param.setCurrentPage;
    // 현재페이지 State props필요
    var next = function() {
        setCurrentPage(function(page) {
            return page + 1;
        });
    };
    var prev = function() {
        setCurrentPage(function(page) {
            return page - 1;
        });
    };
    var handleActive = function(item) {
        setCurrentPage(item);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("ul", {
            className: "pagination justify-content-start",
            children: [
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsx("li", {
                    onClick: prev,
                    className: "page-item",
                    children: currentPage === 1 ? null : /*#__PURE__*/ _jsx("a", {
                        className: "page-link",
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "fi-rs-angle-double-small-left"
                        })
                    })
                }),
                getPaginationGroup.map(function(item, index) {
                    return /*#__PURE__*/ _jsx("li", {
                        onClick: function() {
                            return handleActive(item);
                        },
                        className: currentPage === item ? "page-item active" : "page-item",
                        children: /*#__PURE__*/ _jsx("a", {
                            className: "page-link",
                            children: item
                        })
                    }, index);
                }),
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsx("li", {
                    onClick: next,
                    className: "page-item",
                    children: currentPage >= pages ? null : /*#__PURE__*/ _jsx("a", {
                        className: "page-link",
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "fi-rs-angle-double-small-right"
                        })
                    })
                }),
                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ _jsxs("li", {
                    className: "d-flex align-items-center ml-10",
                    children: [
                        currentPage,
                        " / ",
                        pages
                    ]
                })
            ]
        })
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Pagination)));


/***/ }),

/***/ 85830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filterList_FilterList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/filterList/FilterList.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #ececec;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  border-bottom: 1px solid #ececec;\n  :last-of-type {\n    border: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 160px;\n  padding: 10px;\n  background-color: #3bb77e;\n  color: #fff;\n\n  .expand {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  & li {\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    position: relative;\n    & a {\n      color: #121212;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      padding: 0px 10px;\n      :hover {\n        text-decoration: underline !important;\n      }\n    }\n    .active {\n      background-color: #3bb77e;\n      color: #fff;\n      border-radius: 10px;\n    }\n    & span {\n      display: none;\n      justify-content: center;\n      align-items: center;\n      border-radius: 100%;\n      position: absolute;\n      top: 0px;\n      right: 0px;\n      background-color: #fff;\n      box-shadow: 0px 1px 1px #12121259;\n      color: #253d4e;\n      height: 15px;\n      width: 15px;\n      font-size: 8px;\n      padding: 8px;\n      border: 1px solid #ececec;\n      margin: 0px;\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n    :hover {\n      & span {\n        display: flex;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  .all {\n    min-width: 160px;\n    border-right: 1px solid #ececec;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    & a {\n      display: flex;\n      align-items: center;\n      padding: 10px;\n      cursor: pointer;\n\n      & i {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-left: 5px;\n      }\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        '\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n\n  & li {\n    display: flex;\n    align-items: center;\n\n    & a {\n      color: #3bb77e !important;\n      font-weight: 500;\n      position: relative;\n      padding: 5px 10px;\n\n      ::after {\n        margin: 0px 5px;\n        content: "X";\n      }\n    }\n  }\n'
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 50px;\n  border-top: 2px solid #121212;\n  border-bottom: 2px solid #121212;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px 0px;\n  border-bottom: 1px solid #ececec;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    width: 15%;\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .btnWrapper {\n    width: 15%;\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .name {\n    }\n    .golgi {\n      width: 7%;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .name {\n      width: 25%;\n    }\n    .sizes {\n      display: none;\n    }\n    .strength {\n      width: 10%;\n    }\n    .feature {\n      width: 10%;\n    }\n    .golgi {\n    }\n    .onePrice {\n    }\n    .quantity {\n    }\n    .price {\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}

var FilterListSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-0"
})(_templateObject());
// -------------------- filter ------------------------
var FilterWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-1"
})(_templateObject1());
var FilterRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-2"
})(_templateObject2());
var FilterRowTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-3"
})(_templateObject3());
var FilterRowList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-4"
})(_templateObject4());
var FilteredListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-5"
})(_templateObject5());
var CheckedFilters = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-91adbd0c-6"
})(_templateObject6());
// -------------------- list ------------------------
var ListWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-91adbd0c-7"
})(_templateObject7());
var ListSortWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-8"
})(_templateObject8());
var ListViewTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-9"
})(_templateObject9());
var ListViewSelectBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-10"
})(_templateObject10());
var ProductsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-11"
})(_templateObject11());
var ProductsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-12"
})(_templateObject12(), function(props) {
    return props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)";
});
var ProductsSignWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-13"
})(_templateObject13());
// table type list
var TableTypeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91adbd0c-14"
})(_templateObject14());
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-91adbd0c-15"
})(_templateObject15());

// EXTERNAL MODULE: ./components/ecommerce/Filter/SizeFilter.js
var SizeFilter = __webpack_require__(82763);
;// CONCATENATED MODULE: ./components/filterList/Filter.js





var Filter = function(props) {
    var ref2, ref1;
    var handleQuery = props.handleQuery, filters = props.filters, queries = props.queries, handleSizeFilter = props.handleSizeFilter;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: ((ref2 = Object.keys(filters)) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterWrapper, {
            children: [
                Object.keys(filters).map(function(filter, i) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                        children: ((ref = filters[filter].values) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                                    children: filters[filter].name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                                    children: filters[filter].values.map(function(row, rowIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                onClick: function() {
                                                    return handleQuery(filters[filter].type, row.value);
                                                },
                                                className: "".concat(queries[filters[filter].type] && queries[filters[filter].type].includes(row.value) && "active"),
                                                children: [
                                                    row.name,
                                                    queries[filters[filter].type] && queries[filters[filter].type].includes(row.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fi-rs-cross"
                                                        })
                                                    })
                                                ]
                                            })
                                        }, rowIdx);
                                    })
                                })
                            ]
                        })
                    }, i);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRow, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowTitle, {
                            children: "\uC0AC\uC774\uC988"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRowList, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "d-flex p-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeFilter/* default */.Z, {
                                    handleSizeFilter: handleSizeFilter,
                                    selectedCategory: queries.category_code
                                })
                            })
                        })
                    ]
                }),
                queries && Object.values(queries).filter(function(el) {
                    return el != "";
                }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilteredListWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "all",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: function() {
                                    sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                                        x: window.scrollX,
                                        y: window.scrollY
                                    }));
                                    router.push("", {
                                        query: {}
                                    });
                                },
                                children: [
                                    "\uC804\uCCB4 \uD574\uC81C ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fi-rs-rotate-left"
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedFilters, {
                            children: ((ref1 = Object.keys(queries)) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && Object.keys(queries).map(function(query) {
                                if (query !== "sizes") {
                                    var ref;
                                    return (ref = filters[query]) === null || ref === void 0 ? void 0 : ref.values.map(function(value, vIdx) {
                                        if (queries[query].split(" ").includes(value.value)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                onClick: function() {
                                                    return handleQuery(query, value.value);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: value.name
                                                })
                                            }, vIdx);
                                        } else {
                                            return "";
                                        }
                                    });
                                } else {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: function() {
                                            return handleQuery(query, "");
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "\uC0AC\uC774\uC988 \uD544\uD130"
                                        })
                                    });
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var filterList_Filter = (Filter);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./components/ecommerce/Pagination.js
var Pagination = __webpack_require__(88722);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
// EXTERNAL MODULE: ./components/products/list/TableTypeList.js
var TableTypeList = __webpack_require__(17461);
;// CONCATENATED MODULE: ./components/filterList/FilteredList.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var FilteredList = function(props) {
    var viewType = props.viewType, handleListViewType = props.handleListViewType, dummyList = props.dummyList, filteredList = props.filteredList, addCart = props.addCart, inCart = props.inCart;
    var router = (0,next_router.useRouter)(), limit = 12, showPagination = 5;
    var ref = (0,react.useState)([]), pagination = ref[0], setPagination = ref[1];
    var ref1 = (0,react.useState)([]), paginatedList = ref1[0], setPaginatedList = ref1[1];
    var pages = filteredList && Math.ceil(filteredList.length / limit);
    // pagination
    var createPagination = function() {
        var arr = new Array(pages).fill().map(function(_, idx) {
            return idx + 1;
        });
        setPagination(arr);
    };
    var startIndex = (router.query.page ? Number(router.query.page) : 1) * limit - limit;
    var endIndex = startIndex + limit;
    var start = Math.floor(((router.query.page ? router.query.page : 1) - 1) / showPagination) * showPagination;
    var end = start + showPagination;
    var getPaginationGroup = pagination.slice(start, end);
    // 페이지 네이션
    var next = function() {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: start + 6
            })
        });
    };
    var prev = function() {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: start
            })
        });
    };
    var handleActive = function(page) {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        router.push({
            pathname: "",
            query: _objectSpread({}, router.query, {
                page: page
            })
        });
    };
    (0,react.useEffect)(function() {
        if (filteredList) {
            createPagination();
            setPaginatedList(filteredList.slice(startIndex, endIndex));
        }
    }, [
        filteredList,
        router.query.page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListWrapper, {
            style: {
                borderBottom: "none"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListSortWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewTypeWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "me-2",
                                    children: [
                                        "\uCD1D ",
                                        filteredList.length,
                                        "\uAC1C\uC758 \uC0C1\uD488"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListViewSelectBox, {
                                    listViewType: viewType ? viewType : "grid",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: !viewType || viewType === "grid" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("grid");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-grid"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: viewType && viewType === "list" ? "selected" : "",
                                            onClick: function() {
                                                return handleListViewType("list");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-list"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsWrapper, {
                    children: [
                        (!viewType || viewType === "grid") && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsGrid, {
                            children: paginatedList && paginatedList.map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                                        product: item,
                                        dummyList: dummyList,
                                        addCart: addCart,
                                        inCart: inCart
                                    })
                                }, i);
                            })
                        }),
                        viewType && viewType === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableTypeList/* default */.Z, {
                                productList: paginatedList,
                                dummyList: dummyList,
                                addCart: addCart,
                                inCart: inCart,
                                viewFeature: true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pagination-area mb-15",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": "Page navigation",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "pagination justify-content-center",
                            children: [
                                start == 0 || getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: prev,
                                    className: "page-item",
                                    children: (router.query.page ? router.query.page : 1) == 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-left"
                                        })
                                    })
                                }),
                                getPaginationGroup.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        onClick: function() {
                                            return handleActive(item);
                                        },
                                        className: (router.query.page ? router.query.page : 1) == item ? "page-item active" : "page-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "page-link",
                                            children: item
                                        })
                                    }, index);
                                }),
                                getPaginationGroup.length <= 0 || pages <= 5 || end > pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    onClick: next,
                                    className: "page-item",
                                    children: (router.query.page ? router.query.page : 1) >= pages ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "page-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-angle-double-small-right"
                                        })
                                    })
                                }),
                                getPaginationGroup.length <= 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "d-none d-md-flex align-items-center ml-10",
                                    children: [
                                        "\uCD1D ",
                                        pages,
                                        " \uD398\uC774\uC9C0"
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var filterList_FilteredList = (FilteredList);

;// CONCATENATED MODULE: ./components/filterList/FilterList.js
function FilterList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FilterList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FilterList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var FilterList = function(props) {
    var dummyList = props.dummyList, productList = props.productList, addCart = props.addCart, inCart = props.inCart;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(""), viewType = ref3[0], setViewType = ref3[1];
    var ref1 = (0,react.useState)([]), filteredList = ref1[0], setFilteredList = ref1[1];
    var ref2 = (0,react.useState)({}), filters = ref2[0], setFilters = ref2[1];
    var handleListViewType = function(type) {
        if (viewType === type) {
            return;
        }
        localStorage.setItem("P_viewType", type);
        setViewType(type);
    };
    var _query = router.query, page = _query.page, queries = _objectWithoutProperties(_query, [
        "page"
    ]);
    // 필터 라우팅
    var handleQuery = function(type, value) {
        sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
            x: window.scrollX,
            y: window.scrollY
        }));
        if (type === "sizes") {
            var sizes = queries.sizes, rest = _objectWithoutProperties(queries, [
                "sizes"
            ]);
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, rest)
            });
            return;
        }
        var prevQuery = queries[type];
        var query = "";
        if (prevQuery && prevQuery.split(" ").includes(value)) {
            // 이미 선택된 값이면 제거
            var tempArr = prevQuery.split(" ");
            var idx = tempArr.findIndex(function(el) {
                return el === value;
            });
            tempArr.splice(idx, 1);
            query = tempArr.join(" ");
        } else {
            // 새 값 추가 - 모든 타입에서 다중 선택 허용
            if (queries[type]) {
                query = "".concat(prevQuery, " ").concat(value);
            } else {
                query = value;
            }
        }
        if (!queries[type]) {
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, FilterList_defineProperty({}, type, value))
            });
        } else {
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, FilterList_defineProperty({}, type, query))
            });
        }
    };
    // 필터 만들기
    var getFilters = function() {
        var ref;
        // 1. 먼저 전체 제품에서 사용 가능한 카테고리 추출
        var productsCate = [];
        productList.forEach(function(el) {
            if (!productsCate.includes(el.category_code)) {
                productsCate.push(el.category_code);
            }
        });
        // 2. 카테고리 필터 생성
        var categories = dummyList === null || dummyList === void 0 ? void 0 : (ref = dummyList.category) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return productsCate.includes(el.code);
        });
        var categoryFilter = {
            type: "category_code",
            name: "\uCE74\uD14C\uACE0\uB9AC",
            values: categories ? categories.map(function(el) {
                return {
                    name: el.name,
                    value: el.code
                };
            }) : []
        };
        // 3. 선택된 카테고리에 따라 제품 필터링
        var filteredProducts = productList;
        // 선택된 카테고리가 있으면 해당 카테고리 상품만 필터링
        if (queries.category_code) {
            var selectedCategories = queries.category_code.split(" ");
            filteredProducts = productList.filter(function(product) {
                return selectedCategories.includes(product.category_code);
            });
        }
        // 4. 필터링된 제품에서 세부 카테고리와 주원료 추출
        var productsHash = [];
        var productsFeature = [];
        filteredProducts.forEach(function(el) {
            // 세부 카테고리 추출
            if (el.category_tag && !productsHash.includes(el.category_tag)) {
                productsHash.push(el.category_tag);
            }
            // 주원료 추출
            if (el.feature && el.feature !== "" && !productsFeature.includes(el.feature)) {
                productsFeature.push(el.feature);
            }
        });
        // 5. 세부 카테고리 필터 생성
        var categoryTagFilter = {
            type: "category_tag",
            name: "\uC138\uBD80 \uCE74\uD14C\uACE0\uB9AC",
            values: []
        };
        if (productsHash.length > 0) {
            var tempArr = [];
            productsHash.forEach(function(hashs) {
                hashs === null || hashs === void 0 ? void 0 : hashs.split(",").forEach(function(el) {
                    if (!tempArr.includes(el)) tempArr.push(el);
                });
            });
            categoryTagFilter.values = tempArr.map(function(el) {
                return {
                    name: el,
                    value: el
                };
            });
        }
        // 6. 주원료 필터 생성
        var featureFilter = {
            type: "feature",
            name: "\uC8FC\uC6D0\uB8CC",
            values: []
        };
        if (productsFeature.length > 0) {
            featureFilter.values = productsFeature.map(function(el) {
                return {
                    name: el,
                    value: el
                };
            });
        }
        // 7. 필터 상태 업데이트
        setFilters(FilterList_objectSpread({}, filters, {
            category_code: categoryFilter,
            category_tag: categoryTagFilter,
            feature: featureFilter
        }));
    };
    // queries로 필터 적용
    var filtering = function() {
        if (Object.keys(router.query) && Object.values(router.query).filter(function(el) {
            return el != "";
        }).length > 0) {
            var query = queries;
            var filterKeys = Object.keys(queries);
            var tempList = productList;
            filterKeys.forEach(function(key) {
                if (!query[key] || query[key] === "") return;
                tempList = tempList.filter(function(el) {
                    if (!query[key]) return true;
                    if (key === "sizes") {
                        var ref = JSON.parse(query.sizes), height = ref.height, horizontal = ref.horizontal, range = ref.range, vertical = ref.vertical;
                        if (horizontal > 0 && Number(horizontal) - Number(range) <= Number(el.horizontal) && Number(el.horizontal) <= Number(horizontal) + Number(range) || vertical > 0 && Number(vertical) - Number(range) <= Number(el.vertical) && Number(el.vertical) <= Number(vertical) + Number(range) || height > 0 && Number(height) - Number(range) <= Number(el.height) && Number(el.height) <= Number(height) + Number(range)) {
                            return true;
                        }
                        return false;
                    } else if (key === "category_code") {
                        // 카테고리 다중 선택 처리
                        var selectedCategories = query[key].split(" ");
                        return selectedCategories.includes(el[key]) || selectedCategories.length === 0;
                    } else if (key === "category_tag") {
                        // 세부 카테고리 다중 선택 처리
                        if (query[key] === "") return true;
                        var selectedTags = query[key].split(" ");
                        var productTags = el[key].split(",");
                        // 선택된 태그 중 하나라도 제품 태그에 포함되면 포함
                        return selectedTags.some(function(tag) {
                            return productTags.includes(tag);
                        }) || selectedTags.length === 0;
                    } else if (key === "feature") {
                        // 주원료 다중 선택 처리
                        if (query[key] === "") return true;
                        var selectedFeatures = query[key].split(" ");
                        return selectedFeatures.includes(el[key]) || selectedFeatures.length === 0;
                    } else {
                        // 기타 필터링
                        var selectedValues = query[key].split(" ");
                        return selectedValues.includes(el[key]) || selectedValues.length === 0;
                    }
                });
            });
            setFilteredList(tempList);
        } else {
            setFilteredList(productList);
        }
    };
    var handleSizeFilter = function(sizes) {
        var height = sizes.height, horizontal = sizes.horizontal, range = sizes.range, vertical = sizes.vertical;
        if (sizes) {
            sessionStorage.setItem("__next_scroll_".concat(router.pathname), JSON.stringify({
                x: window.scrollX,
                y: window.scrollY
            }));
            router.push({
                pathname: "",
                query: FilterList_objectSpread({}, queries, {
                    sizes: JSON.stringify(sizes)
                })
            });
        }
    };
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (localStorage.getItem("P_viewType")) {
            setViewType(localStorage.getItem("P_viewType"));
        } else {
            setViewType("list");
        }
        var routeChangeCompleteHandler = function() {
            // 페이지 이동 후 저장되어 있던 위치로 스크롤 복원
            var _scroll = sessionStorage.getItem("__next_scroll_".concat(router.pathname));
            if (_scroll) {
                // 스크롤 복원 후 저장된 위치 제거
                var ref = JSON.parse(_scroll), x = ref.x, y = ref.y;
                window.scrollTo(x, y);
                sessionStorage.removeItem("__next_scroll_".concat(router.pathname));
            }
        };
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        return function() {
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady
    ]);
    (0,react.useEffect)(function() {
        if (!productList || !dummyList) return;
        getFilters();
        filtering();
    }, [
        productList,
        dummyList,
        router.query
    ]);
    // 페이지 진입 시 쿼리 초기화를 위한 코드 추가
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        var isPrintPage = router.pathname.includes("/print");
        var hasNoQuery = Object.keys(router.query).length === 0;
        // viewType 로컬스토리지 값 복원
        var savedViewType = localStorage.getItem("P_viewType");
        setViewType(savedViewType || "list");
        var routeChangeCompleteHandler = function() {
            var _scroll = sessionStorage.getItem("__next_scroll_".concat(router.pathname));
            if (_scroll) {
                var ref = JSON.parse(_scroll), x = ref.x, y = ref.y;
                window.scrollTo(x, y);
                sessionStorage.removeItem("__next_scroll_".concat(router.pathname));
            }
        };
        router.events.on("routeChangeComplete", routeChangeCompleteHandler);
        return function() {
            router.events.off("routeChangeComplete", routeChangeCompleteHandler);
        };
    }, [
        router.isReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterListSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filterList_Filter, {
                    handleQuery: handleQuery,
                    filters: filters,
                    queries: queries,
                    handleSizeFilter: handleSizeFilter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(filterList_FilteredList, {
                    viewType: viewType,
                    handleListViewType: handleListViewType,
                    dummyList: dummyList,
                    filteredList: filteredList,
                    addCart: addCart,
                    inCart: inCart
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var filterList_FilterList = ((0,es/* connect */.$j)(mapStateToProps, null)(FilterList));


/***/ })

}]);